import { Route } from '../types/routes';
import { FallbackPage } from '../features/landing/pages/FallbackPage';
import { TermsPage, TermsPage2024 } from '../features/terms/pages/TermsPageEmbedPdf';

export const genericFallbackRoute: Route = {
  to: '/fallback',
  path: 'fallback',
  Component: FallbackPage,
  name: 'Fallback',
};

export const genericFallbackRoutes: Route[] = [genericFallbackRoute];

export const termsRoutes: Route[] = [
  genericFallbackRoute,
  {
    to: '',
    path: '',
    Component: TermsPage,
    name: 'Terms',
  },
  {
    to: '/septiembre2024',
    path: 'septiembre2024',
    Component: TermsPage2024,
    name: 'Terms2024',
  },
];
